import { Uuid } from '@ftr/contracts/type/shared'
import { GoldSttContext, matchGoldSttContext } from './gold-stt-context'

/*
 * This is used by the Shared Recording Playback Page.
 * We listen to socket events based on the SharedRecordingId.
 * We query data based on the AudioSegmentId.
 */

export interface GoldSharedRecordingSttContext {
  type: 'shared-recording'
  sharedRecordingId: Uuid
  audioSegmentId: Uuid
}

export function buildGoldSharedRecordingSttContext(
  sharedRecordingId: Uuid,
  audioSegmentId: Uuid,
): GoldSharedRecordingSttContext {
  return {
    type: 'shared-recording',
    sharedRecordingId,
    audioSegmentId,
  }
}

export const goldSharedRecordingSttContextEquals =
  (other: GoldSttContext) =>
  (self: GoldSharedRecordingSttContext): boolean =>
    matchGoldSttContext(other, {
      mapSharedRecording: ({ sharedRecordingId }) => sharedRecordingId === self.sharedRecordingId,
      mapAudioOrder: () => false,
      mapRecording: () => false,
    })
